import './create.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import CreateForm from './components/form';
import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content landingSnippets-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='landing-snippets/' className="link">{ props.intl('Return to list of landing metrics') }</Link>
				</div>
				<div className="container__content-title-position">
					<h2 className="title">{ props.intl('Create new landing metric') }</h2>
				</div>
			</div>
			<div className="container__content-body">
				<CreateForm {...props}/>
			</div>
		</div>
	</Animate>
), 'create');

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		error: selectors.getError(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/landing-snippets/create.js